export const HeroFallback = () => <div className={'h-16 w-full bg-black/40 sm:h-18'} />;
